<template>
  <section style="margin: 18px;">
    <v-flex style="text-align: center;">
      <v-btn class="btnPromotional" @click="Open_Promotional">Create Promotional Offer</v-btn>
      <v-btn class="btnPromotional" @click="Open_Course_Based">Create Course wise Offer</v-btn>
      <v-btn class="btnPromotional" @click="Open_User_Based">Create Offer Based On User</v-btn>
      <v-btn class="btnPromotional" @click="Open_Purchase_Based">Create Based on Purchase</v-btn>
      <v-btn class="btnPromotional" @click="OpenBuyOneGetOne">Create Buy One Get One Offer</v-btn>
      <v-btn class="btnPromotional" @click="Open_Set_Referal_Rules">Set Referal Rules</v-btn>
    </v-flex>
    <app-promotional :dialog="Promotional" @close="CloseDialog"></app-promotional>
    <app-course-wise ref="GetCourseDetails" :dialog="Course_Based" @close="CloseDialog"></app-course-wise>
    <app-user-based :dialog="User_Based" @close="CloseDialog"></app-user-based>
    <app-purchase :dialog="Purchase_Based" @close="CloseDialog"></app-purchase>
    <app-buy-one-get-one :dialog="BuyOneGetOne" @close="CloseDialog"></app-buy-one-get-one>
    <set-referal-rules ref="GetReferralRules" :dialog="Set_Referal_Rules" @close="CloseDialog"></set-referal-rules>
    <app-offer-table></app-offer-table>
  </section>
</template>
<script>
  import appPromotional from "../views/dialogs/Offers/Promotional";
  import appCourseWise from "../views/dialogs/Offers/CourseWise";
  import appUserBased from "../views/dialogs/Offers/UserBased";
  import appPurchase from "../views/dialogs/Offers/PurchaseBased";
  import appOfferTable from "../views/tables/OffersTable";
  import appBuyOneGetOne from '../views/dialogs/Offers/BuyOnegetOne'
  import SetReferalRules from '../views/dialogs/Offers/SetReferalRules'

export default {
  components: {
    appPromotional,
    appCourseWise,
    appUserBased,
    appPurchase,
    appOfferTable,
    appBuyOneGetOne,
    SetReferalRules
  },
  data() {
    return {
       
      Promotional        : false,
      Course_Based       : false,
      User_Based         : false,
      CashBack           : false,
      Purchase_Based     : false,
      Set_Referal_Rules  : false,
      BuyOneGetOne       : false

    };
  },
  methods: {
    Open_Promotional() {
      this.Promotional = true;
    },
    Open_Course_Based() {
      this.$refs.GetCourseDetails.GetCourseListFromDB();
      this.Course_Based = true;
    },
    Open_User_Based() {
      this.User_Based = true;
    },
    Open_CashBack() {
      this.CashBack = true;
    },
    Open_Purchase_Based() {
      this.Purchase_Based = true;
    },
    Open_Set_Referal_Rules() {

      this.$refs.GetReferralRules.GetCurrentDetails()
      this.Set_Referal_Rules = true;
    },
    OpenBuyOneGetOne(){
      this.BuyOneGetOne = true
    },
    
    CloseDialog() {

      this.Promotional       = false;
      this.Course_Based      = false;
      this.User_Based        = false;
      this.CashBack          = false;
      this.Purchase_Based    = false;
      this.BuyOneGetOne      = false;
      this.Set_Referal_Rules = false;

    }
  },
  mounted(){
    this.$eventHub.$emit("LOADING",'false')
  }
};
</script>
<style>
.btnPromotional {
  font-size: 10px;
}
</style>
